module.exports = __webpack_public_path__ + "static/media/agregar-cliente.6f99850b.png";